import { Autocomplete, DatePicker } from '@fullscreendigital/carrefour-dex-fe'
import { getCurrentDate, getPreviousWeek } from 'utils/helpers'

export const getColumns = () => [
  {
    title: 'Nr. PV',
    field: 'pvNumber',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Societate',
    field: 'legalEntity',
    align: 'left',
    type: 'string',
    sticky: true,
    disableSorting: true
  },
  {
    title: 'Locatie',
    field: 'storeName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'SAP ID',
    field: 'sapId',
    align: 'left',
    type: 'string',
    sticky: true,
    disableSorting: true,
    collapsible: true
  },
  {
    title: 'Tip locatie',
    field: 'storeType',
    align: 'left',
    type: 'string',
    sticky: true,
    disableSorting: true,
    collapsible: true
  },
  {
    title: 'Data',
    field: 'date',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Categorii',
    field: 'categories',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true
  },
  {
    title: 'Transportator',
    field: 'carrierName',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Destinatar',
    field: 'companyName',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Greutatea predata (kg)',
    field: 'handedWeight',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true
  },
  {
    title: 'Greutatea din METI (kg)',
    field: 'totalCalculatedWeight',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true
  }
]

const currentDate = getCurrentDate()
const previousWeek = getPreviousWeek()

export const getFilters = (
  legalEntitiesOptions: AutocompleteOption[],
  shopOptions: AutocompleteOption[],
  companyOptions: AutocompleteOption[],
  categoryOptions: AutocompleteOption[],
  locationTypesOptions: AutocompleteOption[],
  locationSubtypesOptions: AutocompleteOption[]
) => [
  {
    name: 'legalEntity',
    value: '',
    filter: (
      <Autocomplete variant="outlined" label="Societate" options={legalEntitiesOptions || []} />
    ),
    type: 'autocomplete',
    label: 'Societate'
  },
  {
    name: 'storeIds',
    value: undefined,
    filter: (
      <Autocomplete variant="outlined" label="Magazine" options={shopOptions || []} multiple />
    ),
    type: 'autocomplete',
    label: 'Magazine'
  },
  {
    name: 'subtype.type.id',
    value: '',
    filter: (
      <Autocomplete variant="outlined" label="Tip locatie" options={locationTypesOptions || []} />
    ),
    type: 'autocomplete',
    label: 'Tip locatie'
  },
  {
    name: 'storeType',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Sub-tip locatie"
        options={locationSubtypesOptions || []}
      />
    ),
    type: 'autocomplete',
    label: 'Sub-tip locatie'
  },
  {
    name: 'startDate',
    value: previousWeek,
    filter: (
      <DatePicker
        label="Data inceput"
        variant="outlined"
        value={previousWeek}
        onChange={() => {}}
      />
    ),
    type: 'date',
    label: 'Data inceput'
  },
  {
    name: 'endDate',
    value: currentDate,
    filter: (
      <DatePicker label="Data sfarsit" variant="outlined" value={currentDate} onChange={() => {}} />
    ),
    type: 'date',
    label: 'Data sfarsit'
  },
  {
    name: 'categoryIds',
    value: undefined,
    filter: (
      <Autocomplete variant="outlined" label="Categorii" options={categoryOptions || []} multiple />
    ),
    type: 'autocomplete',
    label: 'Categorii'
  },
  {
    name: 'companyId',
    value: '',
    filter: <Autocomplete variant="outlined" label="Destinatar" options={companyOptions || []} />,
    type: 'autocomplete',
    label: 'Destinatar'
  }
]
